<template>
	<section class="promotions">
		<div class="row blocks-header align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
			</div>
		</div>
		<div class="row promo-row">
			<div
				v-for="(block, index) in items.slice(0, amount)"
				:key="block.ID"
				data-aos="fade-in"
				data-aos-duration="1500"
				data-aos-once="true"
				:data-aos-delay="index + '00'"
				class="promoblock columns column4"
			>
				<div class="content">
					<h3>{{ block.header }}</h3>
					<div v-parse-links v-html="block.content" />
				</div>
				<picture>
					<source v-if="block.imageWebp" :srcset="block.image" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" class="promo-img" loading="lazy" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.promotions {
	padding: 50px 0;
	background: linear-gradient(var(--primary-background-color) 50%, var(--secondary-background-color) 50%);
}

.promo-row {
	width: 100%;
	padding: 20px 0 0;
	text-align: center;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: center;

	.promoblock {
		text-decoration: none;
		margin: 0 auto;
		position: relative;
		width: 31%;
		box-shadow: 0 24px 24px rgb(0 0 0 / 15%);
		padding: 0;

		.content {
			position: absolute;
			top: 50%;
			left: 20px;
			right: 20px;
			margin-top: -100px;
			text-align: center;
			color: #fff;
			z-index: 2;
			display: flex;
			flex-flow: column wrap;
			justify-content: flex-end;
			align-items: center;
			min-height: 220px;

			h2,
			h3,
			h2 a,
			h3 a {
				color: #fff;
				margin: 0 0 30px;
			}

			:deep(a.button-no-fill) {
				border-color: #fff;

				&:hover {
					color: var(--cta-color-hover);
				}
			}
		}

		.promo-img {
			width: 100%;
			transition: all 0.3s ease-in-out;
		}

		&:hover .promo-img {
			opacity: 1;
		}

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background: rgb(0 0 0 / 40%);
			transition: all 0.3s ease-in-out;
		}
	}
}

@media (max-width: 800px) {
	.promotions .promoblock {
		flex-basis: 94%;
		margin: 20px auto;
	}
}
</style>
